module.exports = __webpack_public_path__ + "static/img/no.8b676c3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/no.gif
// module id = wchg
// module chunks = 0